"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

var _localStorage = require("../../../utils/localStorage");

var _recaptcha = _interopRequireDefault(require("../../_common/recaptcha"));

var _dialog = _interopRequireDefault(require("../../_common/dialog"));

var _fullScreen = _interopRequireDefault(require("../../_common/dialog/fullScreen"));

var _nicaLocatorCore = require("../../nicaLocatorCore");

var _tos = require("../survey/tos");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var WelcomeDialog = function WelcomeDialog(_ref) {
  var setShowTos = _ref.setShowTos;

  var _useState = (0, _react.useState)(!(0, _localStorage.getLocal)(_tos.TOS_VERSION)),
      _useState2 = _slicedToArray(_useState, 2),
      show = _useState2[0],
      setShow = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      dontShowChecked = _useState4[0],
      setDontShowChecked = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      valid = _useState6[0],
      setValid = _useState6[1];

  var recaptchaRef = (0, _react.useRef)(null);

  var _useContext = (0, _react.useContext)(_nicaLocatorCore.AppContext),
      welcomeMessage = _useContext.strings.welcomeMessage;

  var content = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", null, "Infusion sites displayed in this tool have been added by either the NICA team through research or by the site itself. NICA is a nonprofit trade association and does not own or operate any infusion sites."), /*#__PURE__*/_react.default.createElement("p", null, "Infusion sites are responsible for adding their center to the locator or claiming an existing center and keeping all information up to date. NICA is not liable for the validity of contact information in a site\u2019s profile."), /*#__PURE__*/_react.default.createElement("p", null, "The locator serves as a free tool to connect patients with the most accessible site of care in their area and for providers to find referral sites. Patients should contact the center directly with all medication, referral, facility, and otherwise site-specific inquiries."));

  var disclaimer = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex flex1"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex align-items-center"
  }, "By continuing you agree to our"), /*#__PURE__*/_react.default.createElement("div", {
    className: "marginLeft5 flex align-items-center locator-survey-form-tos-button"
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    variant: "text",
    color: "secondary",
    onClick: function onClick() {
      return setShowTos(true);
    }
  }, "Terms of Service"))), /*#__PURE__*/_react.default.createElement("div", {
    className: "marginTop20"
  }, /*#__PURE__*/_react.default.createElement(_recaptcha.default, {
    recaptchaRef: recaptchaRef,
    onChange: function onChange() {
      return setValid(true);
    }
  })), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement(_core.FormControlLabel, {
    control: /*#__PURE__*/_react.default.createElement(_core.Checkbox, {
      name: "medication",
      color: "primary",
      checked: dontShowChecked,
      onChange: function onChange(event) {
        setDontShowChecked(event.target.checked);
      }
    }),
    label: /*#__PURE__*/_react.default.createElement("strong", null, "Don't show me this again")
  })));

  var actions = /*#__PURE__*/_react.default.createElement("div", {
    className: "flex justify-end w100",
    style: {
      borderTop: "1px solid rgb(224, 224, 224)"
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    variant: "contained",
    color: "secondary",
    style: {
      margin: 10
    },
    disabled: !valid,
    onClick: function onClick() {
      setShow(false);

      if (dontShowChecked) {
        (0, _localStorage.saveLocal)(_tos.TOS_VERSION, true);
      }
    }
  }, "GOT IT"));

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Hidden, {
    xsDown: true
  }, /*#__PURE__*/_react.default.createElement(_dialog.default, {
    title: "IMPORTANT INFORMATION",
    open: show,
    onClose: function onClose() {},
    actions: actions
  }, welcomeMessage || content, disclaimer)), /*#__PURE__*/_react.default.createElement(_core.Hidden, {
    smUp: true
  }, /*#__PURE__*/_react.default.createElement(_fullScreen.default, {
    open: show,
    title: "Contact ".concat(location.name)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "h100 flex column"
  }, /*#__PURE__*/_react.default.createElement(_core.AppBar, {
    position: "static"
  }, /*#__PURE__*/_react.default.createElement(_core.Toolbar, null, "Important Information")), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex1 scrollY",
    style: {
      padding: "20px"
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "tos-content"
  }, welcomeMessage || content, disclaimer)), /*#__PURE__*/_react.default.createElement("div", null, actions)))));
};

var _default = WelcomeDialog;
exports.default = _default;